
define('eteration/eteration-i18n',['knockout','jquery', 
        'numeral.languages',
        'moment','underscore', 
        'eteration/eteration-async-ajax',
        'ui-helper/cookie-helper',
		'ui-helper/storage-helper'
	],
        function(ko, $, n, moment, underscore, asyncAjax, cookieHelper, storageHelper) {

	var selectedLanguage=null;
	var selectedCountry=null;
	
	var loggedUndefinedLabels = [];

	var localData = window.localStorage;
	var windowSessionData = window.sessionStorage;
	
	var updateBundleStatus = function(bundles, userLang, key) {
		if(sessionData){
			sessionData.setItem(key, JSON.stringify(underscore.union(retrieveBundleStatus(key),bundles).sort()));
		}
	}
	
	var retrieveBundleStatus = function(key) {
		if(sessionData){
			return underscore.isArray(JSON.parse(sessionData.getItem(key))) ? JSON.parse(sessionData.getItem(key)) : [];
		}
		return  [];
	}

	var retrieveBundleStatusForLocalStorage = function(key) {
		if(localData){
			return underscore.isArray(JSON.parse(localData.getItem(key))) ? JSON.parse(localData.getItem(key)) : [];
		}
		return  [];
	}
	
	var calculateBundlesToLoadExp = function(bundles, userLang) {
		if(sessionData){
			var loaded = retrieveBundleStatus("i18n_bundle_names_loaded");
			return underscore.difference(bundles, loaded);
		}
		return  bundles;
	}

	var isExecuted = function(bundleCallbackData) {
		return bundleCallbackData['executed'];
	};
	
	var hasCallback = function(bundleCallbackData) {
		return underscore.isFunction(bundleCallbackData['callback']);
	};
	
	var isRequiredModulesLoaded = function(bundleCallbackData) {
		return underscore.difference(bundleCallbackData['required_bundles'], retrieveBundleStatus("i18n_bundle_names_loaded")).length === 0;
	};
	
	var isBundleCallbackDataGarbage = function(bundleCallbackData) {
		return isExecuted(bundleCallbackData) || !hasCallback(bundleCallbackData);
	};
	
	var executeBundleCallbackData = function(bundleCallbackData) {
		
		if(isExecuted(bundleCallbackData) || !hasCallback(bundleCallbackData) || !isRequiredModulesLoaded(bundleCallbackData)){
			return;
		}
		
		bundleCallbackData['executed'] = true;
		bundleCallbackData['callback']();

	};
	
	var executeEligibleCallbacks = function(userLang) {
		
		//EXECUTE ELIGIBLE CALLBACKS
		underscore.each(window.bundleCallbackDataArray, executeBundleCallbackData);

		//CLEAN EXECUTED CALLBACK
		window.bundleCallbackDataArray = underscore.reject(window.bundleCallbackDataArray, isBundleCallbackDataGarbage);

	};
	
	var removeGarbageBundle = function(name) {
		sessionData.removeItem('i18n_bundle#' + name);
	};

	var removeGarbageBundleForLocalStorage = function(name) {
		localData.removeItem('i18n_bundle#' + name);
	};
	
	
	var clearPreviousLanguageBundles = function(userLang,userCountry){

		if(sessionData){

            if (sessionData.getItem("i18n_language") == userLang ) {
                if(userLang!="pt"){
                    return;
                }
                else if(sessionData.getItem("i18n_country")==userCountry){
                    return;
                }
            }
			
    		underscore.each(retrieveBundleStatus("i18n_bundle_names_loaded"), removeGarbageBundle);

    		sessionData.setItem("i18n_bundle_names_loaded", "[]");
			
    		sessionData.setItem("i18n_language", userLang);
            sessionData.setItem("i18n_country", userCountry);

		}
		
	};

	var getVersionNumberTable = function(){
		if(windowSessionData) {
			var versionNumberTableFound = windowSessionData.getItem("i18n_version_number_table_found");
			if(versionNumberTableFound == null) {
				$.ajax({
					url: "/com.thy.web.online.ibs/ibs/booking/getversionnumbertable",
					type: "GET",
					contentType : "application/json; charset=utf-8",
					dataType : "json",
					cache:false,
					async: true,
					success: function(response) {
						if(response.data){
							windowSessionData.setItem("i18n_version_number_table_found", true);
							if(response.data.ALL){
								var versionNumber = response.data.ALL;
								windowSessionData.setItem("i18n_bundle_session_version_number", versionNumber);
							}
							if(response.data.locationsVersion){
								windowSessionData.setItem("locations_version_number", response.data.locationsVersion);
							}
						}
					}
				});
			}
		}
	};
	getVersionNumberTable();

	var clearLoadedBundlesByVersionNumber = function(){
		if(localData){
			var loadedNames = localData.getItem("i18n_bundle_names_loaded");

			if(loadedNames != null && loadedNames.length > 0){
				underscore.each(retrieveBundleStatusForLocalStorage("i18n_bundle_names_loaded"), removeGarbageBundleForLocalStorage);
				localData.setItem("i18n_bundle_names_loaded", "");
				localData.setItem("i18n_bundle_local_version_number", "");
			}
		}
	};

	clearLoadedBundlesByVersionNumber();
	
	var generateCallbackName = function () {
        var chars = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
 
        var str = '';
        for (var i=0; i<6; i++) {
          var rnum = Math.floor(Math.random() * chars.length);
          str += chars.substring(rnum,rnum+1);
        }
        return str;
    }

	var undefinedLabelCall = function (loggedUndefinedLabels,locale){
		$.ajax({
			url: toCDNPATH("/com.thy.web.online.common/api/translations/undefinedLabel"),
			dataType: "json",
			async: true,
			cache : false,
			data: {"key" : loggedUndefinedLabels, "lang" : locale},
			success: function (response){
			}
		});
	}

	var isAvailabilityPage = function(){
		var availabilityPages = ["/flights/booking/availability",
			"/ucak-bileti/rezervasyon/availability",
			"/ucak-bileti/rezervasyon/ic-hat-musaitlik",
			"/flights/booking/deeplinkprofile",
			"/ucak-bileti/rezervasyon/deeplinkprofil",
			"/ucak-bileti/rezervasyon/coklu-ucus"];

		for(var i=0; i<availabilityPages.length; i++){
			if(window.location.href.includes(availabilityPages[i])){
				return true;
			}
		}

		return false;
	}

	var loadedBundleList = JSON.parse(storageHelper.getItem({ key: "i18n_bundle_names_loaded", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
	setTimeout(function(){
		if(loggedUndefinedLabels.length > 0)
			undefinedLabelCall(loggedUndefinedLabels,i18n.getUserLocale());
	},!isAvailabilityPage() ? 3000 : 10000);

	var isHomePage = function(){
		if(typeof(schedulenewParams) != 'undefined' && schedulenewParams != null && schedulenewParams.mainpage){// /en-int/
			return true;
		}

		return false;
	}
	
    var i18n = {
    		msgStore: {},
    		userLocale : null,
    		loadMsgs: function(bundles,bundlesLoadedCallback, moduleName) {

					if(isHomePage() && moduleName != 'schedulenewAsync'){
						bundles = ['homepage', 'errormessages'];
					}

					if(i18n.getUserLocale() != storageHelper.getItem({ key: "i18n_language", webStorageType: storageHelper.Stores.SESSION_STORAGE }))
						loadedBundleList = null;

    				var userLang = i18n.getUserLocale();
                	var userCountry= i18n.getUserCountry();
    				
    				clearPreviousLanguageBundles(userLang,userCountry);
    				
    				// ADD DEFAULTS IF NOT ADDED
    				if(!isHomePage() || moduleName == 'schedulenewAsync'){
    					bundles = underscore.union(bundles, ["homepage","lookup","errormessages","alphabet","common"]).sort();
    				}

    				moduleName = moduleName || "PLEASE_DEFINE_MODULE_NAME_" + Math.random().toString(36).substring(7);

    				window.bundleCallbackDataArray = window.bundleCallbackDataArray || [];
                    
                    window.bundleCallbackDataArray.push( {'module_name' : moduleName, 'required_bundles' : bundles , 'language' : userLang, 'callback' : bundlesLoadedCallback , 'executed' : false } );
                    
    				var loadExistingBundles = function() {
    					var bundles = underscore.map(retrieveBundleStatus("i18n_bundle_names_loaded"), function(name){ return JSON.parse(sessionData.getItem('i18n_bundle#' + name)) });
    					return underscore.reduce(bundles, function(allBundlesCombined, bundle){ return underscore.extend(allBundlesCombined, bundle); }, {});
					};
    			

    			
    				var asyncCall = false;
    				if(bundlesLoadedCallback){
    					asyncCall = true;
    				}
    				
    				
    				var bundlesToLoad = calculateBundlesToLoadExp(bundles, userLang);


					if(!loadedBundleList){
						loadedBundleList = bundlesToLoad
					}else{
						var bundleList=[];
						for(var i =0;i<bundlesToLoad.length;i++){
							var status = false;
							for(var j=0;j<loadedBundleList.length;j++){
								if(bundlesToLoad[i] == loadedBundleList[j]){
									status = true;
									break;
								}
							}
							if(!status){
								bundleList.push(bundlesToLoad[i]);
								loadedBundleList.push(bundlesToLoad[i]);
							}
						}
						bundlesToLoad = bundleList;
					}
    				if(!sessionData ||(sessionData && bundlesToLoad.length>0)){

    					
        			    updateBundleStatus(bundlesToLoad, userLang, "i18n_bundle_names_currently_loading");


                        var bundle_lang_to_load = userLang;

                        if(userCountry=="br" && userLang=="pt"){
                            /*brezilya portekizcesi */
                            bundle_lang_to_load = "pb";
                        }else if((userCountry=="tw"||userCountry=="hk") && userLang=="zh") {
                            /* taiwan tradional chinese*/
                            bundle_lang_to_load ="zt";
                        }

						var bundleVersionNumber = windowSessionData && windowSessionData.getItem("i18n_bundle_session_version_number") != null ? "?_="+windowSessionData.getItem("i18n_bundle_session_version_number") : "?_="+(new Date(new Date().setMinutes(0,0,0))).getTime();

						$.ajax({
							url: toCDNPATH("/com.thy.web.online.common/api/translations/v2") + bundleVersionNumber,
							dataType: "json",
							async:asyncCall,
							cache : true,
							data: {"bundles":bundlesToLoad,"lang":bundle_lang_to_load},
							beforeSend : function(xhr) {
								xhr.setRequestHeader("Accept-Language", i18n.getUserLocale());
							},
							success: function (response)
							{

								var loadedBundles = response.data.translations;
								underscore.each(loadedBundles, function(value, key){sessionData.setItem('i18n_bundle#' + key, JSON.stringify(value))});

								var loaded = retrieveBundleStatus("i18n_bundle_names_loaded");
								loaded = underscore.union(loaded, underscore.keys(loadedBundles)).sort();
								sessionData.setItem("i18n_bundle_names_loaded", JSON.stringify(loaded));

								var loading = retrieveBundleStatus("i18n_bundle_names_currently_loading");
								loading = underscore.difference(loading, loaded);
								sessionData.setItem("i18n_bundle_names_currently_loading", JSON.stringify(loading));

								window.i18n = i18n;
								window.i18n.msgStore[userLang] = loadExistingBundles();

								executeEligibleCallbacks(userLang);
							}
						});

    				}else if (!window.i18n){
    					var storeObj = loadExistingBundles();
    					i18n.msgStore[userLang] = storeObj;
    					if(window.i18n  && sessionData){
                    		storeObj = loadExistingBundles();
                    		i18n.msgStore[userLang] = storeObj;
                    	}
                        window.i18n = i18n;
					  executeEligibleCallbacks(userLang);

    				}else{
    					  executeEligibleCallbacks(userLang);

    				}
    				i18n.setUserLocaleToLibraries(i18n.getUserLocale());

			},

			getRepeatedTranslatedTextWithArgs : function(key,locale,args) {
				
				locale = locale || i18n.getUserLocale();
				
    			var val;

    			if(i18n.msgStore[locale] && i18n.msgStore[locale][key]){
    				val = i18n.msgStore[locale][key];
    			} else{
    				val = key;
    			}
    			
    			
    			try{
   			     	if(args){
   			     		
   			     		var dataSource = args.dataSource;
   			     		var translationTemplates = args.translationTemplates;
   			     		var dataSeperatorFormat = args.dataSeperatorFormat ? args.dataSeperatorFormat : " ";
   			     		
   			     		if((dataSource && translationTemplates) && ($.isArray(dataSource) && $.isArray(translationTemplates))) {
   			     			
	   			     		var firstIndex = val.indexOf("{");
	   		    			var lastIndex = val.lastIndexOf("}") + 1;
	   		    			
	   		    			var totalContextData = "";
	   		    			
	   		    			for(var j=0; j < dataSource.length; j++) {
	   		    				
	   		    				var dataItem = dataSource[j];
	   		    				var translationFormat = val.substring(firstIndex,lastIndex);
	   		    				
	   			     			for(var i=0; i < translationTemplates.length; i++) {
	   			     				
	   			     				var translationTemplate = translationTemplates[i];
	   			     				
	   			     				if(!translationTemplate)
	   			     					continue;
	   			     				
	   			     				var dataField = translationTemplate["dataField"];
	   			     				var translationKeyword = translationTemplate["translationKeyword"];
	   			     				
	   			     				var contextData = dataItem[dataField];
	   			     				
	   			     				if(!contextData)
	   			     					continue;
	   			     				
	   			     				translationFormat = translationFormat.replace("{"+translationKeyword+"}",contextData);
	   			     			}
	   			     			
	   			     			
	   			     			totalContextData += translationFormat;
	   			     			
	   			     			if(dataSource.length > 1 && j != (dataSource.length - 1)) {
	   			     				totalContextData += dataSeperatorFormat;
	   			     			}
	   		    			}
	   		    			
	   		    			var translationFormat = val.substring(firstIndex,lastIndex);
	   		    			val = val.replace(translationFormat,totalContextData);
   			     		}
   			     		
   			     	}
   			    }catch (e) {
   			    	console.dir(e);
   			    }
   			    
   			    return val;
			},
    		getWithArgs : function(key,args) {
    			 return i18n.get(key,undefined,args);
			},
			getWithDefault : function(key, defaultVal) {
				return i18n.get(key, undefined, undefined, defaultVal);
			},
    		get : function(key , locale, args, defaultVal) {
    			
    			var val = key;
    			if(!locale)
    				locale = i18n.getUserLocale();
    			
    			if(i18n.msgStore[locale]){
    				val =  i18n.msgStore[locale][key];
    			}
    			if(val===undefined) {
    				val = defaultVal ? defaultVal : key;
    			}

    		     try{
    			     if(args){
    			    	 var lookuPluralizeSuffix = "";
    			    	 
    			    	 if(args.countP){
    			    		 var countPropertyValue = args[args.countP];
    			    		 if(countPropertyValue>1){
								 lookuPluralizeSuffix = ".plural"
								 val = i18n.get(key+".plural",locale);
							 }else{
								 val = i18n.get(key+".singular",locale);
							 }
    			    	 }
    			    	 
    			       	 var tokens = val.match(/[^{}]+(?=\})/g);
    			       	 var params = args;
    			     	 if(tokens){	    	 
    			        	 for(var i=0;i<tokens.length;i++){
    			     			    	   
    			        	   var token = tokens[i];
    			     			    	   
    			     			    	   
    				            var functionStart= token.indexOf(":");
    				     		var functionName = null;   	   
    				        	var param;
    				            
    				            if(functionStart<0 && token.indexOf('lookup')>0){
    				              functionName = token;
    				              
    				             if($.inArray(token, args.pluralizeLookpups)>-1){
    				            	 functionName = functionName+lookuPluralizeSuffix;
    				             }

    				              
    				              
    				              var kyz = Object.keys(args);
    				              
    				              for (var int = 0; int < kyz.length; int++) {
    								if(functionName.indexOf(kyz[int])>=0){
    									param = kyz[int];
    								}
    							}
    				              

    				            }
    				            
    				            if(functionStart>0 || functionName!=null){
    				            	var fn;
    				            	 var result ="";
    				                if(functionStart>0){
    				                  functionName = token.substring(functionStart+1,token.length);
    				                  fn = window[functionName];
    				                  param = token.substring(0,functionStart);
    				                  if(fn) {
    				                	  result = fn.apply(this,[params[param]]);
    				                  } else {
    				                	  result = i18n.get(functionName + "." + params[param]);
    				                  }
    				                  val = val.replace("{"+param+":"+functionName+"}",result);
    				                }else{
    	     			                if(lookuPluralizeSuffix){
    	     			                	result = i18n.get(param+ lookuPluralizeSuffix+"."+params[param]);
    	     			                }else{
    	     			                	var fnName= functionName.replace(lookuPluralizeSuffix,"");
    	     			                	fn = window[fnName];
    	     			                	var paramSearch = params[param];
    	     			                	if(paramSearch && paramSearch.replace){
    	     			                		var value = paramSearch.replace(' ', '#!$#');
    	     			                		if(fn) {
    	     			                			result = fn.apply(this,[value]);
    	     			                		} else {
    	     			                			result = i18n.get(fnName + "." + value);
    	     			                		}
    	     			                		
    	     			                	}
    	     			                }
    				                    val = val.replace("{"+functionName+"}",result);
    				                }
    				         	  }else{
    				     		     if(params[token+"Format"]){
    				     		    			params[token] = i18n.momentFormat(params[token], params[token+"Format"]);
    				                 }   
    				     		     
    				     		     var paramVal =  ko.utils.unwrapObservable(params[token]);
    				     			 val = val.replace("{"+token+"}",paramVal);
    				     		  }
    				          }
    			        	 
    			     	 }
    			     }
    		     }catch (e) {
    				console.dir(e);
    			 }
    		     
    		     if(val == key && key != "Label-ALT-Loader" && !loggedUndefinedLabels.includes(key)){
    		    	 loggedUndefinedLabels.push(key);
    		     }
    		     
				return val;
			},
			getWithCountry : function (key, locale, args){
            	var keyWithCountry = key.concat('.' + i18n.getUserCountry());
            	var val = i18n.get(keyWithCountry,locale,args);
            	if(val === keyWithCountry ){
            		val = i18n.get(key,locale,args);
            	}
            	return val;
			},
			getWithOptionalField : function (key, locale, args, optionalField){
				if(Array.isArray(optionalField)){
					optionalField = optionalField.join('.')
				}
            	var keyWithOptionalField = optionalField ? key + '.' + optionalField : key;
            	var val = i18n.get(keyWithOptionalField,locale,args);
            	if(args && args.countP){
	            	var dinamicSuffix = ['.singular', '.plural', '.mono', '.di', '.few', '.many', '.other'];
	            	var req;
	            	underscore.each(dinamicSuffix, function(item){
	            		req = new RegExp(item+'$')
	            		val=val.replace(req,'');
	            	})
            	}
            	
            	if(val === keyWithOptionalField){
            		val = i18n.get(key,locale,args);
            	}
            	return val;
			},
			
			format : function(source,params) {
				if ( arguments.length === 1 ) {
					return function() {
						var args = $.makeArray(arguments);
						args.unshift(source);
						return format.apply( this, args );
					};
				}
				if ( arguments.length > 2 && params.constructor !== Array  ) {
					params = $.makeArray(arguments).slice(1);
				}
				if ( params.constructor !== Array ) {
					params = [ params ];
				}
				$.each(params, function( i, n ) {
					if(n.datePattern){
						n = momentFormat(n.value,n.datePattern);
					}
					source = source.replace( new RegExp("\\{" + i + "\\}", "g"), function() {
						return n;
					});
				});
				return source;
			},

			
			momentFormat : function(value,pattern) {


				var formatter = moment.utc(value);

				if (formatter && formatter.isValid()) {

					return formatter.format(pattern);

				}else{
					return value;
				}

			},
			getLanguageCode: function(index,localeKeyword) {
				
				var code = "en";
				
				if(cookieHelper.getCookie(localeKeyword) != "") {
					var planguageCountry="";
	    			
	    			planguageCountry = cookieHelper.getCookie(localeKeyword);
	    			
	    			if(planguageCountry!=null){
	    				var nlc = 	planguageCountry.split("-");	
	    				if(nlc[index]!=null)
	    					code = nlc[index];
	    			}
	    		}else{
                    if($( "meta[name='languagecountry']" ).attr('content') != null) {
                        var lc = $("meta[name='languagecountry']").attr('content').split("-");
                        if (lc != null)
                            code = lc[index];
                    }
	    		}
				
				return code;
				
			},
			getUserDataFromLocale : function(lang) {
                var code = "en";
				var selectedValue= "en";
				var index=0;
				if(lang==false){
					selectedValue="INT";
					index=1;
				}
				
				if(cookieHelper.getCookie("Locale") == ""&&cookieHelper.getCookie("LocaleOld") != "") {
					var oldLocale = cookieHelper.getCookie("LocaleOld");		
	    			cookieHelper.setCookie("Locale", oldLocale, 365,"/", true);
				}
				
				
				try{
					
						var currentUrl=window.location.href;

						
						var urlContainsLang=(currentUrl.indexOf("-") !=-1);

						if(!urlContainsLang){//only homepage
							
							var localeKeyword = window.useTccPortalLocale ? "TccPortalLocale" : "Locale";
							
							code = i18n.getLanguageCode(index,localeKeyword);
							
						}else{
							if($( "meta[name='languagecountry']" ).attr('content') != null) {
                                var lc = $("meta[name='languagecountry']").attr('content').split("-");
                                if (lc != null)
                                    code = lc[index];
                            }
						}
						selectedValue=code;
					
					
					
				}catch(e){
					
					console.info(e);
					if(index==1){
						selectedValue="INT";
					}else{
						selectedValue="en";
					}
				}
				
				return selectedValue;

				
			},
			getUserLocale : function() {

				if(selectedLanguage!=null){
					return selectedLanguage;
					
				}
				
				selectedLanguage= i18n.getUserDataFromLocale(true);
				
				return selectedLanguage;
			},
			isArabic : function() {
				return i18n.getUserLocale() == "ar";
			},
			getUserCountry : function() {
            


				if(selectedCountry!=null){
					return selectedCountry;
					
				}
				
				selectedCountry= i18n.getUserDataFromLocale(false);
				
				return selectedCountry;
			
			},
			
			
			isUserCountryEqualsTo : function(countryCode) {
				return i18n.getUserCountry().toUpperCase() == countryCode.toUpperCase();
			},
			
			
			isUserLocaleEqualsTo : function(userLocaleCode) {
				return i18n.getUserLocale().toUpperCase() == userLocaleCode.toUpperCase();
			},
			
			
			isUserCountryEqualsToTurkey : function() {
				return i18n.isUserCountryEqualsTo('TR');
			},

			
			isUserLocaleEqualsToTurkish : function() {
				return i18n.isUserLocaleEqualsTo('TR');
			},
			
			
			getMetaDataAttribute : function(attribute) {
				var lc = $('meta[name="'+attribute+'"]')
				if(lc.length){
					var content = lc.attr('content');
					return content;
				}
				return undefined;
			},
			setUserLocaleToLibraries : function(locale) {
				
				var localeForMoment = locale;
				if(locale !='ru' && locale !='uk'){
					if(locale=='zh'){
						locale = 'cn';
						localeForMoment = 'zh-cn';
					}
					moment.locale(localeForMoment);
					if(locale!='ar'){
						numeral.language(locale);
					} else {
						moment.locale(localeForMoment, {
							monthsShort : localeForMoment == 'ar' && ["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],
							months : localeForMoment == 'ar' && ["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],
							weekdaysMin : localeForMoment == 'ar' && "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
							weekdays: localeForMoment == "ar" && "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
							weekdaysShort: localeForMoment == "ar" && "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
							_relativeTime: localeForMoment = "ar" && {future: "في %s", past: "منذ %s", s: "ثوان", ss: "%d ثانية", m: "دقيقة", mm: "%d دقائق", h: "ساعة", hh: "%d ساعات", d: "يوم", dd: "%d أيام", M: "شهر", MM: "%d أشهر", y: "سنة", yy: "%d سنوات"}
						});
					}
				}else{
					
					moment.locale(localeForMoment, {
					    months : localeForMoment =='uk' ? ["січень","лютий","березень","квітень","травень","червень","липень","серпень","вересень","жовтень","листопад","грудень"] : moment.months()
					});
				}
			}
    		
    };

	if (window && window.location && window.location.hostname && window.location.hostname === 'localhost') {
		document.getElementsByTagName('html')[0].setAttribute('dir', (i18n.isArabic() ? 'rtl' : 'ltr'));
	}
	//This attr has been disabled because it will be managed by exlrt.

	window['academictitlelookup']=function (code){
		  return i18n.get("academictitlelookup."+code);
	};
	
	window['ampmlookup']=function (code){
		  return i18n.get("ampmlookup."+code);
	};
	
	window['asistancelookup']=function (code){
		  return i18n.get("asistancelookup."+code);
	};
	
	window['attractionpointlookup']=function (code){
		  return i18n.get("attractionpointlookup."+code);
	};
	
	window['cabintypelookup']=function (code){
		  return i18n.get("cabintypelookup."+code);
	};
	
	window['carrentalwarninglookup']=function (code){
		  return i18n.get("carrentalwarninglookup."+code);
	};
	
	window['carriercodelookup']=function (code){
		  return i18n.get("carriercodelookup."+code);
	};
	
	window['citylookup']=function (code){
		  return i18n.get("citylookup."+code);
	};
	
	window['companysectorlookup']=function (code){
		  return i18n.get("companysectorlookup."+code);
	};
	
	window['countrylookup']=function (code){
		  return i18n.get("countrylookup."+code);
	};
	
	window['familymemberlookup']=function (code){
		  return i18n.get("familymemberlookup."+code);
	};
	
	window['farefamilylookup']=function (code){
		  return i18n.get("farefamilylookup."+code);
	};
	
	window['FFPprogramlookup']=function (code){
		  return i18n.get("FFPprogramlookup."+code);
	};
	
	window['flightstatuslookup']=function (code){
		  return i18n.get("flightstatuslookup."+code);
	};
	
	window['interestlookup']=function (code){
		  return i18n.get("interestlookup."+code);
	};
	
	window['languagelookup']=function (code){
		  return i18n.get("languagelookup."+code);
	};
	
	window['letterlookup']=function (code){
		  return i18n.get("letterlookup."+code);
	};
	
	window['meallistlookup']=function (code){
		  return i18n.get("meallistlookup."+code);
	};
	
	window['milesstatementlookup']=function (code){
		  return i18n.get("milesstatementlookup."+code);
	};
	
	window['mstitlelookup']=function (code){
		  return i18n.get("mstitlelookup."+code);
	};
	
	window['musicaltastelookup']=function (code){
		  return i18n.get("musicaltastelookup."+code);
	};
	
	window['nationalitylookup']=function (code){
		  return i18n.get("nationalitylookup."+code);
	};
	
	window['paxtypelookup']=function (code){
		  return i18n.get("paxtypelookup."+code);
	};
	
	window['paxtypelookup.di']=function (code){
		  return i18n.get("paxtypelookup.di."+code);
	};
	
	window['paxtypelookup.few']=function (code){
		  return i18n.get("paxtypelookup.few."+code);
	};
	

	window['paxtypelookup.mono']=function (code){
		  return i18n.get("paxtypelookup.mono."+code);
	};
	
	window['paxtypelookup.plural']=function (code){
		  return i18n.get("paxtypelookup.plural"+code);
	};
	
	window['planemodellookup']=function (code){
		  return i18n.get("planemodellookup."+code);
	};
	
	window['planetypelookup']=function (code){
		  return i18n.get("planetypelookup."+code);
	};

	window['portcitylookup']=function (code){
		  return i18n.get("portcitylookup."+code);
	};

	window['portcodelookup']=function (code){
		  return i18n.get("portcodelookup."+code);
	};
	
	window['portnamelookup'] = function(code) {
		var portNameArr = code.split(",");
		var tempPortName = "";
		if (portNameArr.length > 1) {
			portNameArr.forEach(function(port) {
				tempPortName += i18n.get("portnamelookup." + port)
						+ ", ";
			});
			tempPortName = tempPortName.slice(0, -2);
		} else {
			tempPortName = i18n.get("portnamelookup." + code);
		}
		return tempPortName;
	};
	
	window['professionlookup']=function (code){
		  return i18n.get("professionlookup."+code);
	};
	
	window['sectorlookup']=function (code){
		  return i18n.get("sectorlookup."+code);
	};
	
	window['securityquestionlookup']=function (code){
		  return i18n.get("securityquestionlookup."+code);
	};
	
	window['specialitylookup']=function (code){
		  return i18n.get("specialitylookup."+code);
	};
	
	window['statelookup']=function (code){
		  return i18n.get("statelookup."+code);
	};
	
	window['taxeslookup']=function (code){
		  return i18n.get("taxeslookup."+code);
	};

	window['terminalinfolookup']=function (code){
		  return i18n.get("terminalinfolookup."+code);
	};

	window['titlelookup']=function (code){
		  return i18n.get("titlelookup."+code);
	};
	
	window['townlookup']=function (code){
		  return i18n.get("townlookup."+code);
	};
	window['triptypelookup']=function (code){
		  return i18n.get("triptypelookup."+code);
	};
	window['countrytypelookup']=function (code){
		  return i18n.get("countrytypelookup."+code);
	};
	window['carcategorylookup']=function (code){
		return i18n.get("carcategorylookup."+code);
	};
	window['bpreasoncodelookup']=function (code){
		return i18n.get("bpreasoncodelookup."+code);
	};

    
    return i18n;
    
});
